replaceGetterValues